import { Box, Text, styled } from '@ltvco/refresh-lib/theme';

import {
  getTableCellPrimaryStyles,
  getTableCellSecondaryStyles,
} from '../../../shared/components';

export const IdbHeaderCell = styled(Box)(({ theme }) => ({
  display: 'flex',
  gap: theme.spacing(0.5),
  alignItems: 'center',
  justifyContent: 'center',
  width: '200px',
  flexShrink: 0,
  [theme.breakpoints.down('sm')]: {
    width: '120px',
    minWidth: '120px',
  },
}));

export const IdbCellWrapper = styled(Box)(({ theme }) => ({
  display: 'flex',
  gap: theme.spacing(4),
  alignItems: 'center',
  flex: 1,
  minWidth: 0,
  [theme.breakpoints.down('sm')]: {
    gap: theme.spacing(1.25),
    flexDirection: 'row',
    alignItems: 'center',
    width: '100%',
  },
}));

export const FieldNameCell = styled(Text)(({ theme }) => ({
  ...getTableCellSecondaryStyles(theme),
  textAlign: 'left',
  width: '200px',
  flexShrink: 0,
  [theme.breakpoints.down('sm')]: {
    width: '120px',
    minWidth: '120px',
    fontSize: '14px',
    lineHeight: '16px',
    flexShrink: 0,
  },
}));

export const ValueCell = styled(Text)(({ theme }) => ({
  ...getTableCellPrimaryStyles(theme),
  textAlign: 'left',
  width: '200px',
  flexShrink: 0,
  [theme.breakpoints.down('sm')]: {
    width: '120px',
    minWidth: '120px',
    fontSize: '14px',
    lineHeight: '20px',
    flexShrink: 0,
  },
}));

export const HintsCell = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  flex: 1,
  minWidth: 0,
  maxWidth: '100%',
  ...getTableCellSecondaryStyles(theme),
  wordWrap: 'break-word',
  overflowWrap: 'break-word',
  [theme.breakpoints.up('md')]: {
    maxWidth: 'calc(100% - 200px)',
  },
  [theme.breakpoints.up('lg')]: {
    maxWidth: 'calc(100% - 250px)',
  },
  '& a': {
    color: theme.palette.primary.main,
    textDecoration: 'none',
    wordBreak: 'break-word',
    overflowWrap: 'break-word',
    '&:hover': {
      textDecoration: 'underline',
    },
  },
  [theme.breakpoints.down('sm')]: {
    flex: '1 1 auto',
    minWidth: '150px',
    fontSize: '14px',
    lineHeight: '20px',
    alignItems: 'center',
  },
}));
